<template>
    <div class="layer-content" style="height:240px;overflow-y:scroll;">
        <div class="info2" style="font-size:16px;color:#000;">접속할 원을 선택하세요.</div>
        <div class="btn-wrap mgt10 mgb20">
            <button v-for="(fcltInfo, index) in mberSrvcFcltList"
                    :key="'mberFcltInfo' + index"
                    :class="[index>0?'mg0 mgt10 ':'','wp100 __layer-type01']"
                    @click="fcltClick(fcltInfo.fcltcd,fcltInfo.srvcCd)">
                <span>{{fcltInfo.fcltNm}}</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "selMberSrvcFclt_popup",
        props:['param'],
        data: function(){
            return {
                mberSrvcFcltList : new Array(),
                srvcCd : ''
            }
        },
        methods: {
            fcltClick:function(fcltcd,srvcCd){

                var param = "?fcltcd=" + fcltcd + "&mberNo=" + this.mberInfo.mberNo + "&srvcCd=" + srvcCd;
                location.href = "/portal/main/remoteLogin.on" + param;
            }
        },
        mounted: function (){
            this.mberSrvcFcltList = this.param.mberSrvcFcltList;
            this.srvcCd = this.param.srvcCd;
        },
        computed: {
            mberInfo: function(){
                return this.$store.getters.getMberInfo;
            },
        }
    }
</script>

<style scoped>

</style>